import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'HOME' },
    { path: '/about', label: 'ABOUT' },
    { path: '/contact', label: 'CONTACT' },
  ];

  const serviceLinks = [
    { path: '/residential-services', label: 'RESIDENTIAL' },
    { path: '/commercial-services', label: 'COMMERCIAL' },
    { path: '/industrial-services', label: 'INDUSTRIAL' },
  ];

  const isServicesActive = serviceLinks.some(link => location.pathname === link.path);
  const isHomePage = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isHomePage && !isScrolled ? 'bg-transparent' : 'bg-navy/95 backdrop-blur-sm shadow-lg'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          <Link to="/" className="flex items-center cursor-pointer">
            <div className="rounded-lg px-3 py-1.5">
              <h1 className="text-xl font-extrabold text-white tracking-tight">NS ELECTRICAL WA</h1>
              <p className="text-[10px] text-gold tracking-widest">LICENSED & INSURED</p>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-semibold tracking-wider transition-colors relative group ${
                  location.pathname === link.path ? 'text-gold' : 'text-white hover:text-gold'
                }`}
              >
                {link.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gold transition-all duration-300 group-hover:w-full"></span>
              </Link>
            ))}
            
            <div 
              className="relative"
              onMouseEnter={() => setIsServicesOpen(true)}
              onMouseLeave={() => setIsServicesOpen(false)}
            >
              <button
                className={`text-sm font-semibold tracking-wider transition-colors relative group flex items-center gap-1 ${
                  isServicesActive ? 'text-gold' : 'text-white hover:text-gold'
                }`}
              >
                SERVICES
                <i className={`ri-arrow-down-s-line text-lg transition-transform ${isServicesOpen ? 'rotate-180' : ''}`}></i>
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gold transition-all duration-300 group-hover:w-full"></span>
              </button>
              
              {isServicesOpen && (
                <div className="absolute top-full left-0 mt-2 bg-navy border-2 border-gold rounded-lg shadow-xl min-w-[200px] overflow-hidden">
                  {serviceLinks.map((link) => (
                    <Link
                      key={link.path}
                      to={link.path}
                      className={`block px-6 py-3 text-sm font-semibold tracking-wider transition-colors border-b border-gold/20 last:border-b-0 ${
                        location.pathname === link.path ? 'text-gold bg-gold/10' : 'text-white hover:text-gold hover:bg-gold/5'
                      }`}
                    >
                      {link.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </nav>

          <a
            href="tel:+61400000000"
            className="hidden lg:flex items-center gap-2 bg-gold text-navy px-6 py-3 rounded-full font-bold text-sm tracking-wider hover:bg-gold-light transition-all whitespace-nowrap cursor-pointer shadow-lg"
          >
            <i className="ri-phone-fill text-lg"></i>
            CALL NOW
          </a>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-gold text-2xl w-10 h-10 flex items-center justify-center cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-navy border-t border-gold/20">
          <nav className="flex flex-col px-6 py-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`py-3 text-sm font-semibold tracking-wider border-b border-white/10 ${
                  location.pathname === link.path ? 'text-gold' : 'text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
            
            <div className="border-b border-white/10">
              <div className="py-3 text-sm font-semibold tracking-wider text-gold">
                SERVICES
              </div>
              {serviceLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`py-2 pl-4 text-sm font-medium tracking-wider block ${
                    location.pathname === link.path ? 'text-gold' : 'text-white'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
            
            <a
              href="tel:+61400000000"
              className="mt-4 flex items-center justify-center gap-2 bg-gold text-navy px-6 py-3 rounded-full font-bold text-sm tracking-wider cursor-pointer"
            >
              <i className="ri-phone-fill text-lg"></i>
              CALL NOW
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;